import dayjs from 'dayjs';

const getTimeSlotDebugInfo = (timeSlot, failures) => {
    const failuresTooltip = failures.length ? `Timeslot ineligible: \n${failures.join('\n')}` : '';
    const { serviceRegionID, startDate, startTime, } = timeSlot;
    const tooltipPrefix = `${serviceRegionID}/${startDate}/${startTime}\n`;
    const disabled = !!failures.length;
    const tooltip = timeSlot.tooltip
        ? `${timeSlot.tooltip}\n${tooltipPrefix}${failuresTooltip}`
        : `${tooltipPrefix}${failuresTooltip}`;
    return {
        ...timeSlot,
        disabled,
        tooltip,
    };
};
/**
 * Returns timeslots that are not disabled. This is useful during debug mode
 * when all timeslots get returned, but with the disabled flag set if
 * ineligible.
 *
 * Usage:
 * const eligibleTimeSlots = getEligibleTimeSlots(timeSlotsByDate);
 * console.info(eligibleTimeSlots);
 */
const getEligibleTimeSlots = (timeSlotsByDate) => {
    const eligibleTimeSlotsByDate = {};
    Object.entries(timeSlotsByDate).forEach(([date, timeSlots]) => {
        Object.entries(timeSlots).forEach(([time, timeSlot]) => {
            if (!timeSlot.disabled) {
                eligibleTimeSlotsByDate[date] = {
                    ...eligibleTimeSlotsByDate[date],
                    [time]: timeSlot,
                };
            }
        });
    });
    return eligibleTimeSlotsByDate;
};
/**
 * Used to clean up the time slots by date object and prevent the returning of
 * empty date objects
 */
const removeEmptyDateObjects = (timeSlotsByDate) => {
    const cleanedTimeSlotsByDate = {};
    Object.entries(timeSlotsByDate).forEach(([date, timeSlotsByTime]) => {
        if (Object.keys(timeSlotsByTime).length > 0) {
            cleanedTimeSlotsByDate[date] = timeSlotsByTime;
        }
    });
    return cleanedTimeSlotsByDate;
};
/**
 * Filter out time slots in the past
 *
 * @param timeSlotsByDate - The time slots by date to filter
 * @param leadTime - The lead time in hours
 * @returns The filtered time slots by date
 */
const filterTimeSlotsByLeadTime = (timeSlotsByDate, leadTime = 0) => {
    const leadTimeDate = dayjs().add(leadTime, 'hours');
    const filteredTimeSlotsByDate = {};
    Object.entries(timeSlotsByDate).forEach(([date, timeSlots]) => {
        const filteredTimeSlots = Object.entries(timeSlots).reduce((acc, [time, timeSlot]) => {
            if (dayjs(timeSlot.startTime).isAfter(leadTimeDate)) {
                acc[time] = timeSlot;
            }
            return acc;
        }, {});
        if (Object.keys(filteredTimeSlots).length) {
            filteredTimeSlotsByDate[date] = filteredTimeSlots;
        }
    });
    return filteredTimeSlotsByDate;
};

export { filterTimeSlotsByLeadTime, getEligibleTimeSlots, getTimeSlotDebugInfo, removeEmptyDateObjects };
